import styled from 'styled-components';

export const InfoContainer = styled.div`
  .risk-label {
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    min-width: 60px;
  }
`;

export const NoRiskLabel = styled.div`
  background-color: #d9d9d9;
  color: #000000;
  padding: 2px 16px;
`;

export const LowRiskLabel = styled.div`
  background-color: #52c41a;
  color: #ffffff;
  padding: 2px 16px;
`;

export const MediumRiskLabel = styled.div`
  background-color: #faad14;
  color: #ffffff;
  padding: 2px 16px;
`;

export const HighRiskLabel = styled.div`
  background-color: #f5222d;
  color: #ffffff;
  padding: 2px 16px;
`;
